import { render, staticRenderFns } from "./SVGStepsZones.vue?vue&type=template&id=635789d7&scoped=true&"
import script from "./SVGStepsZones.vue?vue&type=script&lang=js&"
export * from "./SVGStepsZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635789d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635789d7')) {
      api.createRecord('635789d7', component.options)
    } else {
      api.reload('635789d7', component.options)
    }
    module.hot.accept("./SVGStepsZones.vue?vue&type=template&id=635789d7&scoped=true&", function () {
      api.rerender('635789d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGStepsZones.vue"
export default component.exports